import Vue from 'vue';
var listenList = [];
var imageCatcheList = [];

if(!Array.prototype.remove){
	Array.prototype.remove = function(item){
		if(!this.length) return;
		var index = this.indexOf(item);
		if( index > -1){
			this.splice(index,1);
			return this;
		}
	}
}
// 检测是否已加载
const isAlredyLoad = (imageSrc) => {
	if(imageCatcheList.indexOf(imageSrc) > -1){
		return true;
	}else{
		return false;
	}
}
//检测图片是否可以加载，如果可以则进行加载
const isCanShow = (item) =>{
	var ele = item.ele;
	var src = item.src;

	//图片距离页面顶部的距离
	var top = ele.getBoundingClientRect().top;
	//页面可视区域的高度
	var windowHeight = window.innerHeight || 0;
	//top + 10 已经进入了可视区域10像素
	if(top + 10 <  windowHeight){
		var image = new Image();
		image.src = src;
		image.onload = function(){
			ele.src = src;
			imageCatcheList.push(src);
			listenList.remove(item);
		};
		return true;
	}else{
		return false;
	}
};

const onListenScroll = () =>{
	window.addEventListener('scroll',function(){
		var length = listenList.length;
		for(let i = 0;i<length;i++ ){
			isCanShow(listenList[i]);
		}
	})
}
const addListener = (el) =>{
	//绑定的图片地址
	var imageSrc = el.getAttribute('data-src');
	//如果已经加载过，则无需重新加载，直接将src赋值
	if(isAlredyLoad(imageSrc)){
		el.src = imageSrc;
		return false;
	}
	var item = {
		ele: el,
		src: imageSrc
	};
	//再看看是否可以显示此图片
	if(isCanShow(item)){
		return
	}
	//否则将图片地址和元素均放入监听的lisenList里
	listenList.push(item);

	//然后开始监听页面scroll事件
	onListenScroll();
}
Vue.directive('loadzj', {
	// bind表示这个自定义指令一绑定到dom上，就开始自动执行
	bind: (el) => {
		var bigSrc = el.getAttribute('src'),
			smallSrc = bigSrc.replace('img.ysf.mobi/','img.ysf.mobi/images/') + '?width=50&height=50';
		el.setAttribute('src', smallSrc);
		el.setAttribute('data-src', bigSrc);
		let smallImage = new Image();
		smallImage.src = smallSrc;
		smallImage.onload = function(){
			addListener(el)
		};
	},
	// inserted: addListener,
	// updated: addListener,
});



// WEBPACK FOOTER //
// ./src/mytools/directive.js